import React from 'react';

export default () => (
    <svg width="100%" height="100%" viewBox="0 0 56.693 56.693">
        <path d="M41.816,41.819h-6.7v-10.5c0-2.505-0.045-5.726-3.489-5.726c-3.494,0-4.028,2.729-4.028,5.546v10.68h-6.7V20.155h6.437  v2.947h0.09c0.896-1.699,3.086-3.489,6.352-3.489c6.788,0,8.041,4.469,8.041,10.28V41.819z M17.181,17.209  c-2.155,0-3.887-1.745-3.887-3.887c0-2.142,1.732-3.887,3.887-3.887c2.142,0,3.887,1.745,3.887,3.887  C21.068,15.464,19.323,17.209,17.181,17.209z M20.531,41.819h-6.702V20.155h6.702V41.819z" />
    </svg>
);
